<template>
  <div>
    <div>
      <button class="btn btn-info mw mb-3" @click="check">
        {{ "check_limit" | setText("Проверить лимит") }}
      </button>
    </div>

    <div v-if="checked">
      <div v-if="value.limit_status != 'success'">
        <h4 v-if="value.limit_rate <= 1">
          {{
            "need_scoring"
              | setText("Необходим скоринг, чтобы получить доступ к сервису")
          }}
        </h4>
        <h4 v-else-if="value.limit_rate <= 3">
          {{
            "need_scoring_up"
              | setText(
                "Необходим скоринг для получения дополнительного лимита (добавить пластиковую карту)"
              )
          }}
        </h4>
        <h4 v-else-if="value.limit_rate < 5">
          {{ "need_limit_service" | setText("У клиента недостаточно лимита") }}
        </h4>
      </div>

      <div v-if="value.limit_status != 'success'">
        <div
          v-for="(partner, key) in partners"
          :key="key"
          v-show="partner.code === 'uzum-mko'"
        >
          <a
            @click="scoring(partner.code)"
            target="_blank"
            class="btn btn-danger mw mb-3"
            :href="`https://auth.uzumnasiya.uz/?phone=${phone}&callback=${currentRouter}&companyId=${partner.api_public_key}`"
          >
            {{ partner.name }}
          </a>
        </div>
      </div>

      <h5 class="mt-4">
        {{ "access" | setText("Доступ к сервису") }}:
        <b class="text-success" v-if="value.limit_status === 'success'">{{
          "avalible" | setText("Доступен")
        }}</b>
        <b class="text-danger" v-else>
          {{ "no_avalible" | setText("Недоступен") }}
        </b>
      </h5>
      <h6>P: {{ value.limit_rate }}</h6>
    </div>
  </div>
</template>
<script>
import { logger, sha512 } from "../../plugins/functions";
export default {
  created() {},
  methods: {
    sha512: sha512,
    check() {
      this.$loading(true);
      this.getPartners();
    },
    scoring(partnerCode) {
      logger(this.$http, {
        name: "Начало скоринга",
        description: partnerCode,
        model_type: "subscription",
        model_id: this.value.id,
      });
    },
    async uzummko() {
      logger(this.$http, {
        name: `Проверка лимита - ${this.partner["name"]}`,
        description: "Начало запроса",
        model_type: "subscription",
        model_id: this.value.id,
      });

      return this.$http
        .post(
          `${this.partner["endpoint_url"]}v3/uzum/buyer/check-status?companyId=${this.partner["api_public_key"]}`,
          {
            phone: this.phone,
          },
          {
            headers: {
              Authorization: `Bearer ${this.partner["api_secret_key"]}`,
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          try {
            let periods = response.data.data.available_periods;

            if (response.data.data.status == 8) {
              this.checked = false;
              this.$notify({
                title: "!!!",
                message: `Пользователь заблокирован или в черном списке / Foydalanuvchi bloklangan yoki qora ro'yxatga kiritilgan`,
                icon: "ti-save",
                horizontalAlign: "right",
                verticalAlign: "top",
                type: "warning",
              });
              return false;
            }

            this.limit = 0;

            this.limit_preview = 0;

            for (let i = 0; i < periods.length; i++) {
              if (periods[i].period == "003") {
                let avalibleBalance = parseInt(periods[i].available_balance);
                this.limit_preview = avalibleBalance;
              }
              if (
                periods[i].period == 12 ||
                periods[i].period == 6 ||
                periods[i].period == "6 Default" ||
                periods[i].period == "12 Default"
              ) {
                let avalibleBalance = parseInt(periods[i].available_balance);
                this.limit =
                  avalibleBalance > this.limit ? avalibleBalance : this.limit;
              }
            }

            logger(this.$http, {
              name: `Получен результат лимита - ${this.partner["name"]}`,
              description: `Основной лимит: ${this.limit}  / Доп. лимит: ${this.limit_preview}`,
              model_type: "subscription",
              model_id: this.value.id,
            });
          } catch (error) {
            this.limit = 0;
            this.limit_preview = 0;
          }
        })
        .catch((error) => {
          logger(this.$http, {
            name: `Проверка лимита - ${this.partner["name"]}`,
            description: "Ошибка",
            model_type: "subscription",
            model_id: this.value.id,
          });
        })
        .finally(() => {});
    },

    async getPartners() {
      await this.$http.get(`partners?is_list=1&partner_code=uzum-mko`).then((response) => {
        this.partners = response.data.data;
      });

      for (let i = 0; i < this.partners.length; i++) {
        try {
          this.partner = await this.partners[i];
          console.log("PARTNER", this.partner);
          const func = await this.partner.code.replace("-", "");
          console.log("foo", func);
          await this[func]();
        } catch (error) {}
      }

      setTimeout(() => {
        this.checked = true;
        this.value["limit"] = this.limit;
        this.value["limit_preview"] = this.limit_preview;
        this.$emit("input", this.value);
      }, 1000);
    },
  },
  data() {
    return {
      limit: 0,
      limit_preview: 0,
      partners: [],
      partner: null,
      checked: false,
    };
  },
  props: ["phone", "value", "subscription_id"],
  computed: {
    currentRouter() {
      try {
        return `${this.$store.state.host}/api/redirect/subscription/${this.subscription_id}`;
      } catch (error) {
        return "";
      }
    },
  },
  watch: {},
};
</script>